<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <addinvite ref="aInvite" v-if="IsAdmin===true" :poolID="PoolID" :groupID="null"></addinvite>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import addinvite from "../../components/AddInvite.vue"

  export default {
    name: 'PoolTags',
    components: {acheader,acfooter,poolsidebar,addinvite},
    data() {
      return {
        IsAdmin:false,
        PoolID:null
      }
    },

    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);
        this.PoolID=this.$route.params.id;
        this.IsAdmin=this.sdata.activepool.IsAdmin;
    
      });
    }
  }
</script>
